var map = {
	"./binary.jpg": "0b6e",
	"./chickenscratch.jpg": "f067",
	"./cloth.jpg": "fd52",
	"./color.jpg": "45ad",
	"./cubemap.jpg": "a6c3",
	"./drumkit.jpg": "1bd4",
	"./drummachine.jpg": "2e88",
	"./earth.jpg": "402c",
	"./foolpageslider.jpg": "032d",
	"./gameoflife.jpg": "9ea2",
	"./gameoflife3d.jpg": "b217",
	"./happinessreport.jpg": "7a49",
	"./leanclock.jpg": "00d6",
	"./map.jpg": "91d0",
	"./sampler.jpg": "3274",
	"./sequencer.jpg": "83b6",
	"./slidecordion.jpg": "f336",
	"./smartimagemapper.jpg": "afa4",
	"./solarsystem.jpg": "63f9",
	"./sound.jpg": "c3da",
	"./soundmarbles.jpg": "10ce",
	"./soundmeter.jpg": "a699",
	"./spitfire.jpg": "1524",
	"./textclock.jpg": "9773",
	"./thooclock.jpg": "f51d",
	"./thoodo.jpg": "ecb5",
	"./todo.jpg": "b5f3",
	"./whisky.jpg": "6ac3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8763";